module.exports = __webpack_public_path__ + "img/kppz5.e5af135e.png";